import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, useStylesScoped$, Slot } from "@builder.io/qwik";
const VisuallyHidden = component$((props) => {
  useStylesScoped$(`
  
  .visually-hidden:not(:focus):not(:active) {
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
`);
  return /* @__PURE__ */ jsx("span", {
    class: "visually-hidden",
    ...props,
    children: /* @__PURE__ */ jsx(Slot, {})
  });
});
export {
  VisuallyHidden
};
